import React, { createContext, useContext, useMemo } from 'react';

/**
 * Order type constants
 */
export const ORDER_TYPES = {
  ADVISORY: 'ADVISORY',
  ACCOUNT_AND_ORDER: 'ACCOUNT_AND_ORDER',
  DISTRIBUTION: 'DISTRIBUTION',
  ORDER: 'ORDER'
};

// Create context
const OrderTypeContext = createContext(null);

/**
 * OrderTypeProvider - Context provider for order type information
 * @param {Object} props - Component props
 * @param {Object} props.children - Child components
 * @param {Object} props.order - Order data
 */
export const OrderTypeProvider = ({ children, order }) => {
  const orderType = useMemo(() => order?.order_type || null, [order]);

  const value = useMemo(() => ({
    orderType,
    isAdvisory: orderType === ORDER_TYPES.ADVISORY,
    isAccountAndOrder: orderType === ORDER_TYPES.ACCOUNT_AND_ORDER,
    isDistribution: orderType === ORDER_TYPES.DISTRIBUTION,
    isOrder: orderType === ORDER_TYPES.ORDER,
    isEncomenda: orderType === ORDER_TYPES.ORDER
  }), [orderType]);

  return (
    <OrderTypeContext.Provider value={value}>
      {children}
    </OrderTypeContext.Provider>
  );
};

/**
 * useOrderType - Custom hook to consume the OrderTypeContext
 * @returns {Object} Order type information
 */
export const useOrderType = () => {
  const context = useContext(OrderTypeContext);
  if (context === null) {
    throw new Error('useOrderType must be used within an OrderTypeProvider');
  }
  return context;
};

export default OrderTypeContext;